import React, { useEffect } from 'react'
import { usePoints } from 'hooks/usePoints'

import { decodeStorage } from 'functions/storageBase64'

export function Points(props){
    const {
        cardsService
    } = props

    const {
        points,
        setCardEnding
    } = usePoints(decodeStorage('cardending'))

    useEffect(()=>{
        if(decodeStorage('cardending')){
            setCardEnding(decodeStorage('cardending'))
        }
    },[cardsService])

    return(
        points !== null  &&
            <div className="boxPuntos">
                <p className="copyDisponibles">Puntos disponibles</p>
                <p className="puntos">{points ? points : 0}</p>
            </div>
        
    )
}